import AuthActions from '../actions/AuthActionCreator';
import NotificationActions from '../actions/NotificationActionCreator';
import SettingActions from '../actions/SettingActionCreator';

const App = {
    bootstrap: () => {
        NotificationActions.getAll();
        SettingActions.getAll();
        return AuthActions.getCurrentUser();
    }
};

export default App;
